module.exports = __webpack_public_path__ + "images/emoji/baby.1a1902e4d86f2e7384b5.png";